<template>
  <div class="form-group" :class="{ 'has-error' : model.$error }" >
    <label v-if="showLabel" class="control-label col-sm-4">* {{ $options.filters.sentenceCase($t('organisation')) }}:</label>
    <div :class="{ 'col-sm-8': showLabel }">
      <selectize
        class="form-control selectize selectize-single"
        :class="model.$error ? 'has-error red-border' : ''"
        name="company"
        v-model="model.$model"
        :options="clientUsers"
        @input="() => { $emit('input', model.$model) }"/>

      <div v-if="model.$error" class="help-block pull-right">Client is required</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { map } from 'lodash'
import Selectize from '../ext/codium/CodiumSelectize'

export default {
  props: {
    model: {
      required: true
    },
    default: {
      required: false,
      default: null
    },
    showLabel: {
      required: false,
      default: true
    }
  },

  data () {
    return {
      clientUsers: []
    }
  },

  components: {
    Selectize
  },

  created () {
    this.getCompanies({status: 'active'})
      .then((response) => {
        this.clientUsers = map(response.data.data, client => ({id: client.company, text: client.company}))
      })
  },

  methods: {
    ...mapActions('client', ['getCompanies'])
  }
}
</script>
